'use client';

import { usePathname } from 'next/navigation';
import { useEffect } from 'react';

/**
 * Component that adds a canonical link tag to the document head
 * This ensures search engines understand that the apex domain (getlists.io)
 * is the preferred URL for indexing, even though both domains work without redirects
 *
 * This component will only add a canonical tag if one doesn't already exist,
 * ensuring compatibility with pages that define canonical URLs in their metadata
 */
export default function CanonicalTag() {
  const pathname = usePathname();
  const canonicalUrl = `https://getlists.io${pathname}`;

  useEffect(() => {
    // Check if canonical already exists
    const existingCanonical = document.querySelector('link[rel="canonical"]');

    if (!existingCanonical) {
      // Only add canonical tag if it doesn't already exist
      const link = document.createElement('link');
      link.rel = 'canonical';
      link.href = canonicalUrl;
      document.head.appendChild(link);
    }
  }, [canonicalUrl]);

  // Component doesn't render anything visible
  return null;
}
